import React from "react"
import { Auth } from "../../../Components/Views/Auth/Auth"
import { AuthFormView } from "../../../Models/Client/AuthFormView"
import { Helmet } from "react-helmet-async"

export function SignupRoute() {
    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <Auth type={AuthFormView.signup} squashSuccessMessage={false} />
        </>
    )
}
